var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headerPage"},[_c('div',{staticClass:"container-fluid xxl position-relative z-index-1"},[_c('h1',{staticClass:"title-page"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }